import Badge from '@/components/atoms/Badge';
import HashMono from '@/components/atoms/HashMono';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const typeColors = { sov_: 'violet', ast_: 'cyan', scn_: 'gold', ops_: 'success' };
const typeLabels = { sov_: 'Sovereignty', ast_: 'Asset', scn_: 'Scan', ops_: 'Operations' };

const LedgerCard = ({ seal, newest = false, className = '' }) => {
  const type = seal.type || 'ops_';
  const prefix = type.slice(0, 4);
  const color = typeColors[prefix] || 'default';

  return (
    <div
      data-testid={`ledger-card-${seal.hash?.slice(0, 8)}`}
      className={`relative min-w-[260px] border border-signal/10 rounded-lg bg-obsidian-elevated p-4 transition-colors duration-base hover:border-cyan/30 ${newest ? 'ring-1 ring-cyan/30' : ''} ${className}`}
    >
      {newest && <span className="absolute -top-1 -right-1 w-2.5 h-2.5 rounded-full bg-cyan animate-ping" />}
      <div className="flex items-center justify-between mb-2">
        <Badge variant={color}>{typeLabels[prefix] || type}</Badge>
        <span className="font-mono text-[10px] text-steel-muted">{seal.timestamp}</span>
      </div>
      <HashMono hash={seal.hash || ''} chars={8} className="mb-3" />
      <Link
        to={`/ledger-pulse/verify/${seal.hash}`}
        className="inline-flex items-center gap-1 text-xs font-medium text-cyan hover:text-signal transition-colors duration-fast"
      >
        Verify <ArrowRight className="w-3 h-3" />
      </Link>
    </div>
  );
};

export default LedgerCard;
